import * as Types from './types';
import { makeAction } from '@va/store';

export const redirectToAnotherPage = makeAction(Types.REDIRECT_TO_ANOTHER_PAGE, 'url');
export const initialize = makeAction(Types.INITIALIZE);
